module.exports = __webpack_public_path__ + "static/media/29470010-sWg1wSgs.74c63e38.JPG";